module.exports = __webpack_public_path__ + "img/BRX-alt.e9f6bdb5.svg";